<template>
    <b-tabs
        class="lesson-modules-tab apprentice-tab"
        content-class="lesson-modules-content"
        nav-wrapper-class="tab-content-wrapper">
        <b-tab :title="$t('lesson.preparations')">
            <design-2021-lesson-module-lessons-index-component :lesson-module-in="lessonModuleIn">
            </design-2021-lesson-module-lessons-index-component>
        </b-tab>
        <b-tab :title="$t('lesson.assignments')">
            <design-2021-lesson-module-portfolio-edit-component :lesson-module-in="lessonModuleIn">
            </design-2021-lesson-module-portfolio-edit-component>
        </b-tab>
    </b-tabs>
</template>

<script>
export default {
    name: 'design-2021-organization-lesson-module-show-component',
    props: {
        lessonModuleIn: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss"></style>
